
import { computed, defineComponent, onBeforeMount, ref, SetupContext } from "vue";
import BaseModal from "@/components/base/BaseModal.vue";
import { useStore } from "@/store";
import BaseTabs from "@/components/base/BaseTabs.vue";
import BaseTab from "@/components/base/BaseTab.vue";

export default defineComponent({
  name: "TransactionsModal",
  setup(props, { emit }: SetupContext) {
    const store = useStore();
    const tabs = ref([
      {
        title: "Все",
        type: 0,
      },
      {
        title: "Пополнения",
        type: 1,
      },
      {
        title: "Снятия",
        type: 2,
      },
    ]);
    const tabType = ref(0);
    const trans = computed(() => {
      return tabType.value
        ? store.getters.transGet.filter((item: any) => item.isType === tabType.value)
        : store.getters.transGet.map((el) => el);
    });

    const changeTab = (e: any) => {
      tabType.value = e;
    };

    const dateFilter = (date: string) => {
      return new Intl.DateTimeFormat("ru-RU", {
        year: "numeric",
        month: "long",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      }).format(new Date(date));
    };

    return {
      tabs,
      changeTab,
      trans,
      dateFilter,
    };
  },
  components: {
    BaseModal,
    tabs: BaseTabs,
    tab: BaseTab,
  },
});
